import React from 'react';
import { useModal, useStore } from '@hooks';
import { Button } from '@ui';
import { Flex } from 'antd';
import { SubscriptionOrderModal, SubscriptionOrderModalTitle } from '../components/SubscriptionOrderModal';

export const useSubscriptionOrderModal = () => {
    const { open, close } = useModal();
    const store = useStore();
    const { getOrderByUUID } = store.ordersStore;

    const openModal = (klicklyOrderUUID) => {
        getOrderByUUID(klicklyOrderUUID);

        open({
            title: <SubscriptionOrderModalTitle />,
            content: <SubscriptionOrderModal />,
            addStyle: {
                borderBottom: '1px solid transparent',
                marginBottom: '0'
            },
            settings: {
                width: '1100px',
                footer: (
                    <Flex justify='flex-end'>
                        <Button
                            data-e2e='orders_subscription-order-modal_close-btn'
                            style={{ width: '160px' }}
                            padding='8px'
                            onClick={close}
                        >
                            Close
                        </Button>
                    </Flex>
                )
            }
        });
    };

    return { openModal };
};
